export enum ButtonType {
    SMALL = 'small',
    LARGE = 'large'
}

export interface CopyButtonProps {
    id?: string;
    buttonType?: ButtonType.SMALL | ButtonType.LARGE;
    className?: string;
    copyPrompt?: string;
    textToCopy: string;
}